// Placeholder content for Out Of Touch — Hall & Oates Tribute Band

export const BAND = {
  name: "Out Of Touch",
  tagline: "The Music of Hall & Oates",
  longTagline:
    "A live, full-throttle celebration of Daryl & John — every hook, every harmony, every blue-eyed-soul shimmer of the greatest pop-rock duo of all time.",
  // Phrase inside longTagline that should render bold + yellow on the front page.
  taglineHighlight: "greatest pop-rock duo of all time",
  city: "Toronto, ON",
  yearFormed: 2017,
  email: "bmfsam@aol.com",
  phone: "905-955-9170",
  company: "bmf productions inc.",
};

export const TOUR_DATES = [];

export const SETLIST = [
  { title: "Out of Touch", year: 1984, album: "Big Bam Boom" },
  { title: "Maneater", year: 1982, album: "H2O" },
  { title: "Private Eyes", year: 1981, album: "Private Eyes" },
  { title: "I Can't Go For That (No Can Do)", year: 1981, album: "Private Eyes" },
  { title: "Kiss On My List", year: 1980, album: "Voices" },
  { title: "You Make My Dreams", year: 1980, album: "Voices" },
  { title: "Rich Girl", year: 1976, album: "Bigger Than Both of Us" },
  { title: "Sara Smile", year: 1975, album: "Daryl Hall & John Oates" },
  { title: "She's Gone", year: 1973, album: "Abandoned Luncheonette" },
  { title: "Method of Modern Love", year: 1984, album: "Big Bam Boom" },
  { title: "Adult Education", year: 1983, album: "Rock 'n Soul Part 1" },
  { title: "Did It in a Minute", year: 1981, album: "Private Eyes" },
  { title: "Wait For Me", year: 1979, album: "X-Static" },
  { title: "One On One", year: 1982, album: "H2O" },
  { title: "You've Lost That Loving Feeling", year: 1980, album: "Voices" },
  { title: "Say It Isn't So", year: 1983, album: "Rock 'n Soul Part 1" },
];

export const MEMBERS = [
  {
    name: "Justin Maki",
    role: "Lead Vocals · Guitar",
    bio: "Justin's tenor lives in the same neighborhood as Daryl Hall's — soulful, effortless, and built for the high notes. It was difficult to find the kind of voice to recreate Daryl's blue-eyed soul vocals, but Justin nails it! He has a busy music career in his own right, and has released 4 full-length albums. Justin was the FCLMA's 2021 \"Pop Artist of the Year\" and 2022 \"Contemporary Singer-Songwriter of the Year\".  \u00A0\u00A0He was born in Japan and moved to Canada when he was 8 years old.",
    image: "/band/justin_maki.jpg",
  },
  {
    name: "Dave Langguth",
    role: "Drums",
    bio: "Dave is one of Canada's top drummers, Berklee-trained and sponsored by Sonor Drums out of Germany. His versatility and creative talent solidifies the pocket for the band. He toured the world with Nelly Furtado and has played with Rik Emmett, Honeymoon Suite, Streetheart and he currently plays with Kim Mitchell.",
    image:
      "https://customer-assets.emergentagent.com/job_oates-hall-legacy/artifacts/qjeyhons_Screenshot%202026-06-23%20at%2012.16.22%E2%80%AFPM.png",
  },
  {
    name: "David Speck",
    role: "Lead Keyboards · Lead & Background Vocals",
    bio: "As the founder of Out Of Touch and the lead keyboard player, David recreates the notable Wurlitzer and Rhodes sounds that bring the Hall & Oates era to life. David has played with a number of bands, the longest of which was Whiskey Rose. There he played electric pianos, synths and his B3 organ, performing with specific shows dedicated to the music of Dio, Thin Lizzy, Judas Priest and Whitesnake.",
    image:
      "https://customer-assets.emergentagent.com/job_oates-hall-legacy/artifacts/d83wirn7_Screenshot%202026-06-23%20at%2012.07.54%E2%80%AFPM.png",
  },
  {
    name: "Ben Miller",
    role: "Bass · Background Vocals",
    bio: "Ben locks into the pocket with Dave's drumming to lay down a very solid rhythm section. Ben tours with Nate Haller on the Country Rising tour out of Nashville and was the winner of the CCMA award in 2025 as Bass Player of the Year. A graduate of Humber College, Ben's versatility on bass holds him in high regard among his peers.",
    image:
      "https://customer-assets.emergentagent.com/job_oates-hall-legacy/artifacts/bf901rbm_Screenshot%202026-06-23%20at%2012.19.03%E2%80%AFPM.png",
  },
  {
    name: "Jeff Eager",
    role: "Lead Guitar · Background Vocals",
    bio: "Jeff Eager is a multi-instrumentalist, an original artist with two albums under his belt, and a touring and session musician. For years Jeff worked as the guitarist for S-Curve/BMG recording artist Elise LeGrow. Eager has performed on stage with rock icon Lenny Kravitz, backed up Larry Gowan of Styx, and worked with many Canadian stars like Gary Beals, Arkells and John Orpheus.",
    image:
      "https://customer-assets.emergentagent.com/job_oates-hall-legacy/artifacts/37ojr6uh_Screenshot%202026-06-23%20at%2012.57.19%E2%80%AFPM.png",
  },
  {
    name: "Lindsay Clark",
    role: "Keyboards · Synth · Background Vocals",
    bio: "Lindsay has been playing piano/keyboards since the age of 7. Her work as a musician has taken her across North America, parts of Europe and the Bahamas. A multi-instrumentalist (keys, vocals, guitar, banjo, bass and accordian), she has played with artists including Platinum Blonde and Tiffany. She has worked for acclaimed series Classic Albums Live since 2007, playing over 900 shows and 47 different albums, appearing at Massey Hall in over 20 appearances.",
    image: "/band/lindsay_clark.png",
  },
  {
    name: "Rich Grossman",
    role: "Rhythm Guitar",
    bio: "Rich is a highly regarded rhythm guitar player and a graduate of Humber College. His feel and timing supports Hall & Oates music flawlessly. Rich plays in a local band called the Lizards, a PHISH tribute band, and also spends a part of the year in Germany where he tours with a very successful Tina Turner tribute band.",
    image:
      "https://customer-assets.emergentagent.com/job_oates-hall-legacy/artifacts/0sopdzy4_Screenshot%202026-06-23%20at%2012.51.16%E2%80%AFPM.png",
  },
  {
    name: "Gene Hardy",
    role: "Saxophone · Percussion",
    bio: "Gene is a multi-instrumentalist. His versatility on the sax perfectly imitates the soulful tone of Hall & Oates. Gene studied at the Victoria Conservatory of Music. His sounds can be heard on music by the Barenaked Ladies, Big Sugar and Colin James as well as TV shows like General Hospital and numerous appearances on MuchMusic.",
    image:
      "https://customer-assets.emergentagent.com/job_oates-hall-legacy/artifacts/vyjlasn0_Screenshot%202026-06-23%20at%2012.50.05%E2%80%AFPM.png",
  },
];

export const GALLERY = [
  {
    src: "https://customer-assets.emergentagent.com/job_oates-hall-legacy/artifacts/6s6zpfqv_Screenshot%202026-06-23%20at%204.15.47%E2%80%AFPM.png",
    alt: "Bass player on stage under blue lights",
    aspect: "tall",
  },
  {
    src: "https://images.unsplash.com/photo-1501386761578-eac5c94b800a?w=900&q=80",
    alt: "Crowd raised hands at concert",
    aspect: "wide",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_oates-hall-legacy/artifacts/py34uii8_Screenshot%202026-06-23%20at%204.25.27%E2%80%AFPM.png",
    alt: "Drummer behind sparkling Sonor kit with Sabian cymbals",
    aspect: "big",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_oates-hall-legacy/artifacts/4nl5a4nn_Screenshot%202026-06-23%20at%204.18.06%E2%80%AFPM.png",
    alt: "Saxophonist on stage with festival lights",
    aspect: "tall",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_oates-hall-legacy/artifacts/ggwzh4th_Screenshot%202026-06-23%20at%204.20.35%E2%80%AFPM.png",
    alt: "Guitarist in cowboy hat with acoustic guitar at the mic",
    aspect: "big",
  },
  {
    src: "https://images.unsplash.com/photo-1632518073212-5fc10bc60acd?w=1200&q=80",
    alt: "Audience holding their hands in the shape of a heart",
    aspect: "big",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_oates-hall-legacy/artifacts/2bq51ce3_Screenshot%202026-06-23%20at%204.21.30%E2%80%AFPM.png",
    alt: "Keys player with raised hand and purple stage glow",
    aspect: "big",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_oates-hall-legacy/artifacts/x3qi25cs_Screenshot%202026-06-23%20at%204.38.52%E2%80%AFPM.png",
    alt: "Wade O. Brown headshot in blue stage light at the keys",
    aspect: "big",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_oates-hall-legacy/artifacts/ftw2xvip_Screenshot%202026-06-23%20at%205.04.05%E2%80%AFPM.png",
    alt: "Guitarist in beanie singing into the mic, blue stage light",
    aspect: "big",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_oates-hall-legacy/artifacts/p7z3j14n_Screenshot%202026-06-23%20at%204.24.07%E2%80%AFPM.png",
    alt: "Bass player with long hair on outdoor stage",
    aspect: "big",
  },
];

export const VIDEOS = [
  {
    title: "Out of Touch — Live at The Ardmore",
    runtime: "4:32",
    thumb:
      "https://images.unsplash.com/photo-1501612780327-45045538702b?w=1200&q=80",
  },
  {
    title: "Maneater — Live in Asbury Park",
    runtime: "5:18",
    thumb:
      "https://images.unsplash.com/photo-1470225620780-dba8ba36b745?w=1200&q=80",
  },
  {
    title: "You Make My Dreams — Wedding Set",
    runtime: "3:47",
    thumb:
      "https://images.unsplash.com/photo-1524368535928-5b5e00ddc76b?w=1200&q=80",
  },
];

export const PRESS = [
  {
    quote:
      "The closest thing to seeing Daryl and John in their prime — Out Of Touch don't just play the songs, they *inhabit* them.",
    source: "Philadelphia Weekly",
  },
  {
    quote:
      "Tight, soulful, and absolutely dialed-in. The harmonies alone are worth the ticket.",
    source: "Asbury Park Press",
  },
  {
    quote:
      "A masterclass in blue-eyed soul. We had the dance floor packed inside of three songs.",
    source: "Marisol & Adam, married Sep '25",
  },
  {
    quote:
      "Out Of Touch closed our festival and the crowd would not leave. That's all you need to know.",
    source: "Riverfront Summer Series",
  },
];
